import { GridColDef } from '@mui/x-data-grid-premium';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import { EnhancedDetailPanel } from 'components/enhanced/data-grid/components';
import { memo } from 'react';
import { inventoryCheckLineService } from 'shared/services';

type InventoryCheckDetailPanelProps = {
  row: {
    id: number;
  };
  columns: GridColDef[];
};

const InventoryCheckDetailPanel = ({ row, columns }: InventoryCheckDetailPanelProps) => {
  return (
    <EnhancedDetailPanel>
      <EnhancedDataGrid
        columns={columns}
        service={inventoryCheckLineService}
        outerParams={{
          inventory_check: row.id
        }}
      />
    </EnhancedDetailPanel>
  );
};

export default memo(InventoryCheckDetailPanel);
